import React, { useState } from "react";
import AsyncSelect from "react-select/async";
import { components } from "react-select";
import { Form } from "react-bootstrap";
import { getSelectGetDynamicData } from "../pages/generic/crud";

const ClearIndicator = (props) => (
  <components.ClearIndicator {...props}>
    <i
      className="bi bi-x-circle-fill"
      style={{ fontSize: "14px", color: "#f1416c", opacity: 0.5, cursor: "pointer" }}
      onMouseEnter={(e) => (e.target.style.opacity = 0.9)}
      onMouseLeave={(e) => (e.target.style.opacity = 0.5)}
    />
  </components.ClearIndicator>
);

const DropdownIndicator = (props) => {
  if (props.hasValue) return null;
  return <components.DropdownIndicator {...props} />;
};

export function AGCDynamicSelect({ entityId, formik, isMulti, name, toolTip, value, id, forUpdate = false, required = true, searchField = 'name' }) {
    const [inputValue, setInputValue] = useState('');

    const loadOptions = (inputValue, callback) => {
        getSelectGetDynamicData(entityId, inputValue, searchField).then(({ data }) => {
            callback(data);
        }).catch(() => {
            callback([]);
        });
    };

    return (
        <>
            <Form.Label className={required ? 'required' : ''}>{name}</Form.Label>
            <AsyncSelect
                isMulti={isMulti}
                isClearable={!forUpdate}
                value={value}
                getOptionLabel={(option) => option.name || option.label}
                getOptionValue={(option) => option.id || option.value}
                inputValue={inputValue}
                onInputChange={setInputValue}
                loadOptions={loadOptions}
                isDisabled={forUpdate}
                components={{ ClearIndicator, DropdownIndicator, IndicatorSeparator: ({ hasValue, ...props }) => hasValue ? null : <components.IndicatorSeparator {...props} /> }}
                onChange={option => {
                    // Normalize the option to have both id/name and value/label fields
                    const normalizedOption = option ? {
                        ...option,
                        id: option.id || option.value,
                        name: option.name || option.label,
                        value: option.value || option.id,
                        label: option.label || option.name,
                    } : null;
                    formik.setFieldValue(id, normalizedOption);
                }}
                placeholder="Search..."
                noOptionsMessage={({ inputValue }) =>
                    inputValue ? "No matches found" : "Start typing to search..."
                }
            />
            <Form.Text className="text-muted">{toolTip}</Form.Text>
        </>
    );
}
